<div class="AdvancedTypeahead__Wrapper">
  <div class="AdvancedTypeahead__Opening">
    <input
      (keyup.enter)="onOptionClick(searchInput.value)"
      [formControl]="searchInput"
      class="input AdvancedTypeahead__InputInner"
      [attr.maxlength]="maxOptionLength"
      (click)="onIconClick()"
    />
    <div (click)="onIconClick()" class="AdvancedTypeahead__OpeningArrow">
      <i class="icon">{{ showDropdown ? 'close' : 'carat_down' }}</i>
    </div>
  </div>

  @if (showDropdown) {
    <div class="AdvancedTypeahead__Options">
      <div class="AdvancedTypeahead__Spacer"></div>

      @if (loading) {
        <preloader size="medium"></preloader>
      }
      @if (searchInput.value) {
        <div
          class="AdvancedTypeahead__Option"
          (click)="onOptionClick(searchInput.value)"
        >
          <div
            class="AdvancedTypeahead__OptionInner"
            data-test-id="searchInputValue"
          >
            <b>{{ searchInput.value }}</b>
          </div>
        </div>
      }
      @for (option of filteredOptions; track option) {
        <div class="AdvancedTypeahead__Option" (click)="onOptionClick(option)">
          <div class="AdvancedTypeahead__OptionInner">{{ option }}</div>
        </div>
      }

      <div class="AdvancedTypeahead__Spacer"></div>

      @if (newOptionIsTooLong) {
        <p
          class="AdvancedTypeahead__TooManyLabelsWarning"
          data-test-id="tooManyLabelsWarning"
        >
          <i class="icon AdvancedTypeahead__TooManyLabelsWarningIcon">warning</i
          >{{ config.maxLabelLengthWarning }}
        </p>
      }
    </div>
  }
</div>
